import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AwardComponent } from './award.component';
import { StandartCardAwardComponent } from './standart_card_award/standart_card_award.component';
import { NamedCardAwardComponent } from './named_card_award/named_card_award.component';
import { CertificateAwardComponent } from './certificate_award/certificate_award.component';
import { WordSlicePipe } from '@pipes/word-slice.pipe';

@NgModule({
    imports: [CommonModule, HttpClientModule, FormsModule],
    declarations: [
        AwardComponent,
        StandartCardAwardComponent,
        NamedCardAwardComponent,
        CertificateAwardComponent,
        WordSlicePipe
    ],
    exports: [AwardComponent, WordSlicePipe],
    providers: []
})
export class AwardModule {}
